module.exports = __webpack_public_path__ + "img/rx.13f0ca75.png";